import { FunctionComponent } from "react";

const Templates: {
  [key: string]: FunctionComponent;
} = {};

Templates.KontentItemImage = require("./kontentItemImage").default;
Templates.KontentItemCtaButton = require("./kontentItemCtaButton").default;
Templates.KontentItemImageButton = require("./kontentItemImageButton").default;

export default Templates;
